import React, { useState } from "react";

const WORKFORCE_DATA = {
  "1 week": [
    { month: "Mon", fullLabel: "Monday", newHires: 3, exits: 1 },
    { month: "Tue", fullLabel: "Tuesday", newHires: 5, exits: 0 },
    { month: "Wed", fullLabel: "Wednesday", newHires: 2, exits: 2 },
    { month: "Thu", fullLabel: "Thursday", newHires: 8, exits: 1 },
    { month: "Fri", fullLabel: "Friday", newHires: 6, exits: 3 },
    { month: "Sat", fullLabel: "Saturday", newHires: 1, exits: 0 },
    { month: "Sun", fullLabel: "Sunday", newHires: 0, exits: 0 },
  ],
  "3 week": [
    { month: "Week 1", fullLabel: "Week 1 (Jul 21 - Jul 27)", newHires: 14, exits: 3 },
    { month: "Week 2", fullLabel: "Week 2 (Jul 28 - Aug 03)", newHires: 18, exits: 5 },
    { month: "Week 3", fullLabel: "Week 3 (Aug 04 - Aug 10)", newHires: 20, exits: 4 },
  ],
  "1 month": [
    { month: "W1", fullLabel: "Week 1 (Aug 01 - Aug 07)", newHires: 12, exits: 3 },
    { month: "W2", fullLabel: "Week 2 (Aug 08 - Aug 14)", newHires: 15, exits: 2 },
    { month: "W3", fullLabel: "Week 3 (Aug 15 - Aug 21)", newHires: 11, exits: 4 },
    { month: "W4", fullLabel: "Week 4 (Aug 22 - Aug 31)", newHires: 14, exits: 4 },
  ],
  "3 month": [
    { month: "Jun '26", fullLabel: "June 2026", newHires: 48, exits: 9 },
    { month: "Jul '26", fullLabel: "July 2026", newHires: 60, exits: 11 },
    { month: "Aug '26", fullLabel: "August 2026", newHires: 52, exits: 13 },
  ],
  "6 month": [
    { month: "Feb '26", fullLabel: "February 2026", newHires: 28, exits: 8 },
    { month: "Mar '26", fullLabel: "March 2026", newHires: 35, exits: 12 },
    { month: "Apr '26", fullLabel: "April 2026", newHires: 42, exits: 10 },
    { month: "May '26", fullLabel: "May 2026", newHires: 55, exits: 15 },
    { month: "Jun '26", fullLabel: "June 2026", newHires: 48, exits: 9 },
    { month: "Jul '26", fullLabel: "July 2026", newHires: 60, exits: 11 },
    { month: "Aug '26", fullLabel: "August 2026", newHires: 52, exits: 13 },
  ],
  "12 month": [
    { month: "Sep", fullLabel: "September 2025", newHires: 22, exits: 6 },
    { month: "Oct", fullLabel: "October 2025", newHires: 26, exits: 7 },
    { month: "Nov", fullLabel: "November 2025", newHires: 30, exits: 9 },
    { month: "Dec", fullLabel: "December 2025", newHires: 18, exits: 5 },
    { month: "Jan", fullLabel: "January 2026", newHires: 32, exits: 10 },
    { month: "Feb", fullLabel: "February 2026", newHires: 28, exits: 8 },
    { month: "Mar", fullLabel: "March 2026", newHires: 35, exits: 12 },
    { month: "Apr", fullLabel: "April 2026", newHires: 42, exits: 10 },
    { month: "May", fullLabel: "May 2026", newHires: 55, exits: 15 },
    { month: "Jun", fullLabel: "June 2026", newHires: 48, exits: 9 },
    { month: "Jul", fullLabel: "July 2026", newHires: 60, exits: 11 },
    { month: "Aug", fullLabel: "August 2026", newHires: 52, exits: 13 },
  ],
};

const OPTIONS = [
  "1 week",
  "3 week",
  "1 month",
  "3 month",
  "6 month",
  "12 month",
];

const WorkforceMovementChart = ({ data: initialData }) => {
  const [selectedRange, setSelectedRange] = useState("12 month");
  const [hoveredBar, setHoveredBar] = useState(null);

  const chartData = WORKFORCE_DATA[selectedRange] || initialData || WORKFORCE_DATA["12 month"];

  const maxVal = chartData.length
    ? Math.max(...chartData.flatMap((d) => [d.newHires, d.exits]), 1)
    : 1;

  const isManyBars = chartData.length >= 10;

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 flex flex-col justify-between h-full min-h-[320px]">
      {/* Header with Filter */}
      <div>
        <div className="flex items-center justify-between flex-wrap gap-2 mb-3">
          <h3 className="text-sm font-semibold text-slate-800">
            Workforce Movement
          </h3>

          {/* Filter Dropdown */}
          <select
            value={selectedRange}
            onChange={(e) => setSelectedRange(e.target.value)}
            className="rounded-lg border border-slate-200 bg-white px-2.5 py-1 text-xs font-medium text-slate-600 outline-none hover:border-slate-300 focus:border-[#147db5] focus:ring-1 focus:ring-[#147db5] transition-all cursor-pointer"
          >
            {OPTIONS.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        </div>

        {/* Legend */}
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-1.5">
            <span className="h-2.5 w-2.5 rounded-sm bg-blue-500" />
            <span className="text-xs text-slate-500">New Hires</span>
          </div>
          <div className="flex items-center gap-1.5">
            <span className="h-2.5 w-2.5 rounded-sm bg-red-400" />
            <span className="text-xs text-slate-500">Exits (Terminated)</span>
          </div>
        </div>
      </div>

      {/* Chart Container */}
      <div className="relative flex-1 flex items-end justify-between gap-1 pt-4 pb-1 px-0.5 min-h-[180px]">
        {chartData.map((d, i) => {
          const hireH = Math.round((d.newHires / maxVal) * 100);
          const exitH = Math.round((d.exits / maxVal) * 100);
          const isHovered = hoveredBar === i;

          return (
            <div
              key={`${d.month}-${i}`}
              className="flex flex-1 flex-col items-center gap-1 group cursor-pointer relative min-w-0"
              onMouseEnter={() => setHoveredBar(i)}
              onMouseLeave={() => setHoveredBar(null)}
            >
              {/* Tooltip */}
              {isHovered && (
                <div className="absolute z-30 bottom-full mb-2 left-1/2 -translate-x-1/2 rounded-lg border border-slate-200 bg-white px-3 py-2 shadow-xl text-xs text-slate-700 whitespace-nowrap pointer-events-none">
                  <p className="font-semibold text-slate-800 mb-1">
                    {d.fullLabel || d.month}
                  </p>
                  <p className="flex items-center gap-1.5">
                    <span className="h-2 w-2 rounded-full bg-blue-500" />
                    <span className="text-slate-500">New Hires:</span>
                    <span className="font-semibold text-slate-800">
                      {d.newHires}
                    </span>
                  </p>
                  <p className="flex items-center gap-1.5 mt-0.5">
                    <span className="h-2 w-2 rounded-full bg-red-400" />
                    <span className="text-slate-500">Exits:</span>
                    <span className="font-semibold text-slate-800">
                      {d.exits}
                    </span>
                  </p>
                </div>
              )}

              {/* Bars */}
              <div className="flex items-end gap-[1.5px] w-full h-36 justify-center">
                {/* New Hires bar */}
                <div
                  className="flex-1 rounded-t-sm transition-all duration-300"
                  style={{
                    height: `${hireH}%`,
                    backgroundColor: isHovered ? "#2563eb" : "#3b82f6",
                    minHeight: "4px",
                  }}
                />
                {/* Exits bar */}
                <div
                  className="flex-1 rounded-t-sm transition-all duration-300"
                  style={{
                    height: `${exitH}%`,
                    backgroundColor: isHovered ? "#ef4444" : "#f87171",
                    minHeight: "4px",
                  }}
                />
              </div>

              {/* Month / Period label */}
              <span
                className={`font-medium mt-1 text-center leading-none text-slate-500 ${isManyBars ? "text-[9px]" : "text-[10px]"
                  }`}
              >
                {d.month}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WorkforceMovementChart;
